import { cleartaxAxios } from '../http-common';

interface RefundAmountResponse {
  refund_amount: number;
}

export const getRefundAmount = async (): Promise<RefundAmountResponse> => {
  try {
    const { data: result } = await cleartaxAxios.get('/f/refund-calculator/');
    return result.data;
  } catch (error) {
    console.error('Error fetching refund amount:', error);
    throw error;
  }
};
